import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { InitiationItemBgSettingsFragmentDoc, TeleprompterSettingsFragmentDoc, ShowContactSettingsFragmentDoc, ShoppableInteractionOnInitiationItemFragmentDoc, MultipleChoiceInteractionOnInitiationItemFragmentDoc, HotspotInteractionOnInitiationItemFragmentDoc } from './initiation-item-fragment.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiationItemsOnStoryEditorQueryVariables = Types.Exact<{
  initiationId: Types.Scalars['ID']['input'];
}>;


export type InitiationItemsOnStoryEditorQuery = { __typename?: 'RootQueryType', initiationItems?: Array<{ __typename: 'InitiationItem', id: string, databaseId: any, title: string, headline?: string | null, type: Types.InitiationItemType, interactionType: Types.InteractionType, order: number, collectContact: boolean, useTextFallback: boolean, textColor?: string | null, blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, providerName?: string | null, oembedResult?: any | null, video?: { __typename?: 'VideoUpload', id: string, thumbUrl?: string | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null } | null, interactions: Array<{ __typename: 'HotspotInteraction', id: string, type: Types.InteractionType, hotspotInteractionId: string, hotspots: Array<{ __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null } }> } | { __typename: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType, multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } } | { __typename: 'ShoppableInteraction', id: string, type: Types.InteractionType, count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }>, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } | null, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null } | null> | null };

export type InitiationItemsOnStoryPlayerQueryVariables = Types.Exact<{
  initiationId: Types.Scalars['ID']['input'];
}>;


export type InitiationItemsOnStoryPlayerQuery = { __typename?: 'RootQueryType', initiationItems?: Array<{ __typename?: 'InitiationItem', id: string, databaseId: any, title: string, type: Types.InitiationItemType, order: number, collectContact: boolean, content?: { __typename?: 'Content', id: string, groupType: Types.ContentGroupType, type: Types.ContentType, providerName?: string | null, videoContain?: boolean | null, oembedResult?: any | null, narration?: { __typename?: 'ContentNarration', id: string, type?: Types.NarrationType | null } | null } | null } | null> | null };

export type InitiationItemsForStoryEditorStepsInsightQueryVariables = Types.Exact<{
  initiationId: Types.Scalars['ID']['input'];
}>;


export type InitiationItemsForStoryEditorStepsInsightQuery = { __typename?: 'RootQueryType', initiationItems?: Array<{ __typename: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number, interactions: Array<{ __typename?: 'HotspotInteraction', id: string, type: Types.InteractionType } | { __typename?: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType } | { __typename?: 'ShoppableInteraction', id: string, type: Types.InteractionType }> } | null> | null };

export type InitiationItemsForSelectQueryVariables = Types.Exact<{
  initiationId: Types.Scalars['ID']['input'];
}>;


export type InitiationItemsForSelectQuery = { __typename?: 'RootQueryType', initiationItems?: Array<{ __typename?: 'InitiationItem', id: string, title: string, order: number, collectContact: boolean } | null> | null };

export type InitiationItemsForWidgetPreviewQueryVariables = Types.Exact<{
  initiationId: Types.Scalars['ID']['input'];
}>;


export type InitiationItemsForWidgetPreviewQuery = { __typename?: 'RootQueryType', initiationItems?: Array<{ __typename?: 'InitiationItem', id: string, content?: { __typename?: 'Content', id: string, video?: { __typename?: 'VideoUpload', id: string, thumbUrl?: string | null } | null } | null } | null> | null };


export const InitiationItemsOnStoryEditorDocument = gql`
    query initiationItemsOnStoryEditor($initiationId: ID!) {
  initiationItems(initiationId: $initiationId) {
    id
    databaseId
    title
    headline
    type
    interactionType
    order
    collectContact
    useTextFallback
    textColor
    ...InitiationItemBgSettings
    ...ShowContactSettings
    content {
      id
      type
      groupType
      providerName
      oembedResult
      video {
        id
        thumbUrl
      }
      image {
        ...StepImageUploadOnFeed
      }
    }
    interactions {
      id
      type
      ... on ShoppableInteraction {
        ...ShoppableInteractionOnInitiationItem
      }
      ... on MultipleChoiceInteraction {
        ...MultipleChoiceInteractionOnInitiationItem
      }
      ... on HotspotInteraction {
        ...HotspotInteractionOnInitiationItem
      }
    }
    question {
      id
      title
      titleColor
      showTitle
      timing
      choices {
        id
        type
        hasNext
        text
        value
        order
        nextPage {
          id
          title
          type
          order
        }
      }
    }
    __typename
  }
}
    ${InitiationItemBgSettingsFragmentDoc}
${ShowContactSettingsFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}
${ShoppableInteractionOnInitiationItemFragmentDoc}
${MultipleChoiceInteractionOnInitiationItemFragmentDoc}
${HotspotInteractionOnInitiationItemFragmentDoc}`;

/**
 * __useInitiationItemsOnStoryEditorQuery__
 *
 * To run a query within a React component, call `useInitiationItemsOnStoryEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemsOnStoryEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemsOnStoryEditorQuery({
 *   variables: {
 *      initiationId: // value for 'initiationId'
 *   },
 * });
 */
export function useInitiationItemsOnStoryEditorQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemsOnStoryEditorQuery, InitiationItemsOnStoryEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemsOnStoryEditorQuery, InitiationItemsOnStoryEditorQueryVariables>(InitiationItemsOnStoryEditorDocument, options);
      }
export function useInitiationItemsOnStoryEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemsOnStoryEditorQuery, InitiationItemsOnStoryEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemsOnStoryEditorQuery, InitiationItemsOnStoryEditorQueryVariables>(InitiationItemsOnStoryEditorDocument, options);
        }
export type InitiationItemsOnStoryEditorQueryHookResult = ReturnType<typeof useInitiationItemsOnStoryEditorQuery>;
export type InitiationItemsOnStoryEditorLazyQueryHookResult = ReturnType<typeof useInitiationItemsOnStoryEditorLazyQuery>;
export type InitiationItemsOnStoryEditorQueryResult = Apollo.QueryResult<InitiationItemsOnStoryEditorQuery, InitiationItemsOnStoryEditorQueryVariables>;
export function refetchInitiationItemsOnStoryEditorQuery(variables: InitiationItemsOnStoryEditorQueryVariables) {
      return { query: InitiationItemsOnStoryEditorDocument, variables: variables }
    }
export const InitiationItemsOnStoryPlayerDocument = gql`
    query initiationItemsOnStoryPlayer($initiationId: ID!) {
  initiationItems(initiationId: $initiationId) {
    id
    databaseId
    title
    type
    order
    collectContact
    content {
      id
      groupType
      type
      providerName
      videoContain
      oembedResult
      narration {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useInitiationItemsOnStoryPlayerQuery__
 *
 * To run a query within a React component, call `useInitiationItemsOnStoryPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemsOnStoryPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemsOnStoryPlayerQuery({
 *   variables: {
 *      initiationId: // value for 'initiationId'
 *   },
 * });
 */
export function useInitiationItemsOnStoryPlayerQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemsOnStoryPlayerQuery, InitiationItemsOnStoryPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemsOnStoryPlayerQuery, InitiationItemsOnStoryPlayerQueryVariables>(InitiationItemsOnStoryPlayerDocument, options);
      }
export function useInitiationItemsOnStoryPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemsOnStoryPlayerQuery, InitiationItemsOnStoryPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemsOnStoryPlayerQuery, InitiationItemsOnStoryPlayerQueryVariables>(InitiationItemsOnStoryPlayerDocument, options);
        }
export type InitiationItemsOnStoryPlayerQueryHookResult = ReturnType<typeof useInitiationItemsOnStoryPlayerQuery>;
export type InitiationItemsOnStoryPlayerLazyQueryHookResult = ReturnType<typeof useInitiationItemsOnStoryPlayerLazyQuery>;
export type InitiationItemsOnStoryPlayerQueryResult = Apollo.QueryResult<InitiationItemsOnStoryPlayerQuery, InitiationItemsOnStoryPlayerQueryVariables>;
export function refetchInitiationItemsOnStoryPlayerQuery(variables: InitiationItemsOnStoryPlayerQueryVariables) {
      return { query: InitiationItemsOnStoryPlayerDocument, variables: variables }
    }
export const InitiationItemsForStoryEditorStepsInsightDocument = gql`
    query initiationItemsForStoryEditorStepsInsight($initiationId: ID!) {
  initiationItems(initiationId: $initiationId) {
    id
    title
    type
    order
    __typename
    interactions {
      id
      type
    }
  }
}
    `;

/**
 * __useInitiationItemsForStoryEditorStepsInsightQuery__
 *
 * To run a query within a React component, call `useInitiationItemsForStoryEditorStepsInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemsForStoryEditorStepsInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemsForStoryEditorStepsInsightQuery({
 *   variables: {
 *      initiationId: // value for 'initiationId'
 *   },
 * });
 */
export function useInitiationItemsForStoryEditorStepsInsightQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemsForStoryEditorStepsInsightQuery, InitiationItemsForStoryEditorStepsInsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemsForStoryEditorStepsInsightQuery, InitiationItemsForStoryEditorStepsInsightQueryVariables>(InitiationItemsForStoryEditorStepsInsightDocument, options);
      }
export function useInitiationItemsForStoryEditorStepsInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemsForStoryEditorStepsInsightQuery, InitiationItemsForStoryEditorStepsInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemsForStoryEditorStepsInsightQuery, InitiationItemsForStoryEditorStepsInsightQueryVariables>(InitiationItemsForStoryEditorStepsInsightDocument, options);
        }
export type InitiationItemsForStoryEditorStepsInsightQueryHookResult = ReturnType<typeof useInitiationItemsForStoryEditorStepsInsightQuery>;
export type InitiationItemsForStoryEditorStepsInsightLazyQueryHookResult = ReturnType<typeof useInitiationItemsForStoryEditorStepsInsightLazyQuery>;
export type InitiationItemsForStoryEditorStepsInsightQueryResult = Apollo.QueryResult<InitiationItemsForStoryEditorStepsInsightQuery, InitiationItemsForStoryEditorStepsInsightQueryVariables>;
export function refetchInitiationItemsForStoryEditorStepsInsightQuery(variables: InitiationItemsForStoryEditorStepsInsightQueryVariables) {
      return { query: InitiationItemsForStoryEditorStepsInsightDocument, variables: variables }
    }
export const InitiationItemsForSelectDocument = gql`
    query initiationItemsForSelect($initiationId: ID!) {
  initiationItems(initiationId: $initiationId) {
    id
    title
    order
    collectContact
  }
}
    `;

/**
 * __useInitiationItemsForSelectQuery__
 *
 * To run a query within a React component, call `useInitiationItemsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemsForSelectQuery({
 *   variables: {
 *      initiationId: // value for 'initiationId'
 *   },
 * });
 */
export function useInitiationItemsForSelectQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemsForSelectQuery, InitiationItemsForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemsForSelectQuery, InitiationItemsForSelectQueryVariables>(InitiationItemsForSelectDocument, options);
      }
export function useInitiationItemsForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemsForSelectQuery, InitiationItemsForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemsForSelectQuery, InitiationItemsForSelectQueryVariables>(InitiationItemsForSelectDocument, options);
        }
export type InitiationItemsForSelectQueryHookResult = ReturnType<typeof useInitiationItemsForSelectQuery>;
export type InitiationItemsForSelectLazyQueryHookResult = ReturnType<typeof useInitiationItemsForSelectLazyQuery>;
export type InitiationItemsForSelectQueryResult = Apollo.QueryResult<InitiationItemsForSelectQuery, InitiationItemsForSelectQueryVariables>;
export function refetchInitiationItemsForSelectQuery(variables: InitiationItemsForSelectQueryVariables) {
      return { query: InitiationItemsForSelectDocument, variables: variables }
    }
export const InitiationItemsForWidgetPreviewDocument = gql`
    query initiationItemsForWidgetPreview($initiationId: ID!) {
  initiationItems(initiationId: $initiationId) {
    id
    content {
      id
      video {
        id
        thumbUrl
      }
    }
  }
}
    `;

/**
 * __useInitiationItemsForWidgetPreviewQuery__
 *
 * To run a query within a React component, call `useInitiationItemsForWidgetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemsForWidgetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemsForWidgetPreviewQuery({
 *   variables: {
 *      initiationId: // value for 'initiationId'
 *   },
 * });
 */
export function useInitiationItemsForWidgetPreviewQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemsForWidgetPreviewQuery, InitiationItemsForWidgetPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemsForWidgetPreviewQuery, InitiationItemsForWidgetPreviewQueryVariables>(InitiationItemsForWidgetPreviewDocument, options);
      }
export function useInitiationItemsForWidgetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemsForWidgetPreviewQuery, InitiationItemsForWidgetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemsForWidgetPreviewQuery, InitiationItemsForWidgetPreviewQueryVariables>(InitiationItemsForWidgetPreviewDocument, options);
        }
export type InitiationItemsForWidgetPreviewQueryHookResult = ReturnType<typeof useInitiationItemsForWidgetPreviewQuery>;
export type InitiationItemsForWidgetPreviewLazyQueryHookResult = ReturnType<typeof useInitiationItemsForWidgetPreviewLazyQuery>;
export type InitiationItemsForWidgetPreviewQueryResult = Apollo.QueryResult<InitiationItemsForWidgetPreviewQuery, InitiationItemsForWidgetPreviewQueryVariables>;
export function refetchInitiationItemsForWidgetPreviewQuery(variables: InitiationItemsForWidgetPreviewQueryVariables) {
      return { query: InitiationItemsForWidgetPreviewDocument, variables: variables }
    }